import { Product } from './products'

/** Maintenance products currently listed in the Pegasus online catalog. */
export const maintenanceProducts: Product[] = [
  {
    name: 'Cover Conditioner',
    sku: '12706',
    price: 8.95,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/shampoo.png',
    alt: 'Bottle of spa cover conditioner',
  },
  {
    name: 'Wonder Flower Scum Sponge',
    sku: '12567',
    price: 6.5,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/img_181_20100604061817_6860_scum_flower_150s.jpg',
    alt: 'Wonder Flower scum-absorbing sponge shaped like a flower',
  },
  {
    name: 'Wipe Out',
    sku: '12586',
    price: 31.98,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/6012.jpg400x400.jpg',
    alt: 'Bottle of Wipe Out spa surface cleaner',
  },
  {
    name: 'Ultra Mitt',
    sku: '12563',
    price: 8.75,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/img_190_20100604061817_6875_duramitt_300s.jpg',
    alt: 'Ultra Mitt spa cleaning mitt',
  },
  {
    name: 'TEAR-AID Vinyl Repair Kit',
    sku: '13844',
    price: 9.1,
    availability: 'In Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/img_1_20110404143357_6420_TEAR-AID_300s.jpg',
    alt: 'TEAR-AID vinyl repair kit package',
  },
  {
    name: 'Swirl Away',
    sku: '12589',
    price: 8.99,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/img_1_20160721155959_1810_SwirlAway_NEW2016_150s.jpg',
    alt: 'Bottle of Swirl Away spa plumbing cleaner',
  },
  {
    name: 'Spa & Pool Vacuum',
    sku: '16825',
    price: 75.0,
    availability: 'In Stock',
    image: 'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/130065.jpg',
    alt: 'Handheld spa and pool vacuum',
  },
  {
    name: 'Scumbug',
    sku: '12564',
    price: 6.5,
    availability: 'Out of Stock',
    image:
      'https://www.pegasus-spas.com/uploaded/images/Ecom%20Products/img_163_20100604061816_6800_scumbug_1pk_150s.jpg',
    alt: 'Scumbug oil-absorbing sponge for spa water',
  },
]
